import SimpleFormPage from "../common/SimpleFormPage";
import AbsenceFields from "./AbsenceFields";

export default function NewAbsence() {
  return (
    <SimpleFormPage title="Nuova assenza">
      <AbsenceFields />
    </SimpleFormPage>
  );
}
